// extracted by mini-css-extract-plugin
module.exports = {"alert":"WLBNotification_alert__1PsQX","content":"WLBNotification_content__2ngOv","whisper":"WLBNotification_whisper__30Jez","text":"WLBNotification_text__2ZhxO"};